"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _axios = _interopRequireDefault(require("axios"));
var _qs = _interopRequireDefault(require("qs"));
const _excluded = ["baseUrl", "additionalHeaders", "xsrfCookieName", "xsrfHeaderName"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const buildConfig = _ref => {
  let {
      baseUrl,
      additionalHeaders,
      xsrfCookieName = 'csrftoken',
      xsrfHeaderName = 'X-CSRFToken'
    } = _ref,
    args = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const config = _objectSpread({
    baseURL: baseUrl,
    headers: additionalHeaders,
    validateStatus: status => {
      return status < 500 && status !== 456;
    },
    xsrfCookieName,
    xsrfHeaderName
  }, args);
  return config;
};

/**
 * Utilities for working with APIs.
 * @module APIUtils
 */
class AxiosInstance {
  constructor(_config) {
    var _this = this;
    /**
     * Creates a default instance of APIUtils.
     * @static
     * @function init
     * @param {Object} config - The configuration object.
     * @param {String} config.baseUrl - The base URL for all API requests in this instance.
     * @param {Object} [config.additionalHeaders] - Additional headers to add to every request.
     * @param {String} [config.xsrfCookieName='csrftoken'] - The name of the cookie to use as a value for the XSRF token.
     * @param {String} [config.xsrfHeaderName='X-CSRFToken'] - The name of the HTTP header that carries the XSRF token value.
     * @example
     * const serviceInstance = APIUtils.init({
     *     baseUrl: 'api/v1',
     *     additionalHeaders: {
     *         UserAgent: 'header-name'
     *     }
     * });
     * @returns {Object} - The axios instance.
     */
    (0, _defineProperty2.default)(this, "init", config => {
      this._axiosInstance = _axios.default.create(buildConfig(config));
      this.attachInterceptor({
        method: 'response',
        fulfilled: response => {
          if (response.status >= 400 && response.status < 500) {
            return Promise.reject(response);
          } else {
            return response;
          }
        },
        rejected: error => {
          return Promise.reject(error);
        }
      });
      return this._axiosInstance;
    });
    /**
     * Attaches an interceptor of the specified method to the axios instance.
     * @static
     * @function attachInterceptor
     * @param {Object} [data={}] - The interceptor data.
     * @param {String} [data.method=null] - The type of method to attach the interceptor to ('request' or 'response').
     * @param {Function} [data.fulfilled=null] - The function to handle `then` for a `Promise`.
     * @param {Function} [data.rejected=null] - The function to handle `reject` for a `Promise`.
     * @example
     * APIUtils.attachInterceptor({
     *     method: 'request',
     *     fulfilled: config => {
     *         ...code here
     *
     *         return config;
     *     },
     *     rejected: error => {
     *         return Promise.reject(error);
     *     }
     * });
     * @returns {void}
     */
    (0, _defineProperty2.default)(this, "attachInterceptor", _ref2 => {
      let {
        method,
        fulfilled,
        rejected
      } = _ref2;
      this._axiosInstance.interceptors[method].use(fulfilled, rejected);
    });
    /**
     * Creates a GET request.
     * @static
     * @function get
     * @param {String} path - The API call path.
     * @param {Object} [data=null] - The parameters to send to the API call.
     * @param {Object} [config=null] - Modifies the <a href="https://github.com/axios/axios#request-config">configuration</a> for the request.
     * @example
     * APIUtils.get('api/v1/test');
     * @returns {AxiosInstance} - The axios instance.
     */
    (0, _defineProperty2.default)(this, "get", (path, data, config) => {
      return this._axiosInstance.get(path, _objectSpread({
        params: data
      }, config));
    });
    /**
     * Creates a POST request.
     * @static
     * @function post
     * @param {String} path - The API call path.
     * @param {Object} [data=null] - The parameters to send to the API call.
     * @param {Object} [config=null] - Modifies the <a href="https://github.com/axios/axios#request-config">configuration</a> for the request.
     * @param {Boolean} [stringify=false] - Whether to encode the data object into a query string.
     * @example
     * APIUtils.post('api/v1/test', data);
     * @returns {AxiosInstance} - The axios instance.
     */
    (0, _defineProperty2.default)(this, "post", function (path, data, config) {
      let stringify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      let formattedData = data;
      if (stringify || (0, _get.default)(config, 'headers.Content-Type', '') === 'application/x-www-form-urlencoded') {
        formattedData = _qs.default.stringify(data);
      }
      return _this._axiosInstance.post(path, formattedData, config);
    });
    /**
     * Creates a PATCH request.
     * @static
     * @function patch
     * @param {String} path - The API call path.
     * @param {Object} [data=null] - The parameters to send to the API call.
     * @param {Object} [config=null] - Modifies the <a href="https://github.com/axios/axios#request-config">configuration</a> for the request.
     * @example
     * APIUtils.patch('api/v1/test', data);
     * @returns {AxiosInstance} - The axios instance.
     */
    (0, _defineProperty2.default)(this, "patch", (path, data, config) => {
      return this._axiosInstance.patch(path, data, config);
    });
    /**
     * Creates a PUT request.
     * @static
     * @function patch
     * @param {String} path - The API call path.
     * @param {Object} [data=null] - The parameters to send to the API call.
     * @param {Object} [config=null] - Modifies the <a href="https://github.com/axios/axios#request-config">configuration</a> for the request.
     * @example
     * APIUtils.put('api/v1/test', data);
     * @returns {AxiosInstance} - The axios instance.
     */
    (0, _defineProperty2.default)(this, "put", (path, data, config) => {
      return this._axiosInstance.put(path, data, config);
    });
    /**
     * Creates a DELETE request.
     * @static
     * @function delete
     * @param {String} path - The API call path.
     * @param {Object} [config=null] - Modifies the <a href="https://github.com/axios/axios#request-config">configuration</a> for the request.
     * @example
     * APIUtils.delete('api/v1/test');
     * @returns {AxiosInstance} - The axios instance.
     */
    (0, _defineProperty2.default)(this, "delete", (path, config) => {
      return this._axiosInstance.delete(path, config);
    });
    /**
     * Allows access to cancel tokens from axios without having to install and manage axios in the project.
     * @static
     * @function getCancelToken
     * @example
     * APIUtils.getCancelToken();
     * @returns {CancelToken} - The axios cancel token.
     */
    (0, _defineProperty2.default)(this, "getCancelToken", () => {
      return _axios.default.CancelToken;
    });
    this._axiosInstance = null;
    if (!(0, _isNil.default)(_config)) {
      this._axiosInstance = this.init(_config);
    }
  }
  /**
   * @type {Object}
   */
  get instance() {
    return this._axiosInstance;
  }

  /**
   * Creates a cancelable promise.
   * @static
   * @function makeCancelable
   * @param {Promise} promise - The promise to make cancelable.
   * @example
   * const dataLoader = APIUtils.makeCancelable(
   *     APIUtils.get('api/v1/test')
   * );
   *
   * dataLoader.cancel();
   * @returns {Object} - An object containing the `promise` as well as the `cancel` method.
   */
  makeCancelable(promise) {
    let hasCanceled = false;
    const wrappedPromise = new Promise((resolve, reject) => {
      promise.then(val => {
        if (hasCanceled) {
          reject({
            isCanceled: true
          }); // eslint-disable-line prefer-promise-reject-errors
        } else {
          resolve(val);
        }
      }).catch(error => {
        if (hasCanceled) {
          reject({
            isCanceled: true
          }); // eslint-disable-line prefer-promise-reject-errors
        } else {
          reject(error);
        }
      });
    });
    return {
      promise: wrappedPromise,
      cancel() {
        hasCanceled = true;
      }
    };
  }
}
var _default = AxiosInstance;
exports.default = _default;